import { supabase } from '../lib/supabase';

const isProduction = import.meta.env.PROD;

export const trackEvent = async (eventName: string, properties: Record<string, any>) => {
  // Skip analytics in development to prevent 404 errors
  if (!isProduction) {
    console.debug('[Analytics Debug]:', { eventName, properties });
    return;
  }

  try {
    await supabase.from('analytics_events').insert({
      event_name: eventName,
      properties,
      timestamp: new Date().toISOString()
    });
  } catch (error) {
    console.error('Error tracking event:', error);
  }
};

export const trackPageView = async (page: string) => {
  await trackEvent('page_view', { page });
};

export const trackTestProgress = async (questionNumber: number, totalQuestions: number) => {
  await trackEvent('test_progress', {
    question_number: questionNumber,
    total_questions: totalQuestions,
    progress_percentage: Math.round((questionNumber / totalQuestions) * 100)
  });
};

export const trackTestCompletion = async (result: {
  primaryArchetype: string;
  secondaryArchetype: string;
  scores: Record<string, number>;
}) => {
  await trackEvent('test_completion', {
    primary_archetype: result.primaryArchetype,
    secondary_archetype: result.secondaryArchetype,
    scores: result.scores
  });
};